import { renderableHtml } from './legacyHtml';
import { parse as parseCss } from 'cssom';

export const templateLabel = (value) =>
  String(value || '').replace(/^"|"$/g, '');

// Old templates keep their layout in style blocks. Scope those rules to an
// inert document and carry the resulting styles into the editable HTML.
export function templateContent(value) {
  const doc = new DOMParser().parseFromString(
    templateLabel(value),
    'text/html'
  );
  const applied = new Map();
  doc.querySelectorAll('style').forEach((style) => {
    let sheet;
    try {
      sheet = new window.CSSStyleSheet();
      if (sheet.replaceSync) sheet.replaceSync(style.textContent);
      else sheet = null;
    } catch (_) {
      sheet = null;
    }
    if (!sheet) {
      // Parse rules as data; never install template CSS in the dashboard.
      try {
        sheet = parseCss(style.textContent);
      } catch (_) {
        return;
      }
    }
    if (!sheet) return;
    Array.from(sheet.cssRules).forEach((rule) => {
      if (!rule.selectorText || !rule.style) return;
      rule.selectorText.split(',').forEach((selector) => {
        // Template selectors are ordinary class, ID and element selectors.
        // Interactive states and pseudo-elements have no static equivalent.
        if (selector.includes(':') && selector.trim() !== ':root') return;
        const specificity =
          (selector.match(/#/g) || []).length * 100 +
          (selector.match(/[.[]/g) || []).length * 10 +
          (selector.match(/(^|\s|>)[a-z]/gi) || []).length;
        let elements;
        try {
          elements = doc.querySelectorAll(selector);
        } catch (_) {
          return;
        }
        elements.forEach((element) => {
          const properties = applied.get(element) || new Map();
          Array.from(rule.style).forEach((name) => {
            const priority = rule.style.getPropertyPriority(name);
            const rank = specificity + (priority ? 10000 : 0);
            if (!properties.has(name) || rank >= properties.get(name).rank) {
              properties.set(name, {
                rank,
                value: rule.style.getPropertyValue(name),
                priority,
              });
            }
          });
          applied.set(element, properties);
        });
      });
    });
  });
  applied.forEach((properties, element) => {
    properties.forEach(({ value, priority }, name) => {
      if (
        !element.style.getPropertyValue(name) ||
        (priority && !element.style.getPropertyPriority(name))
      ) {
        element.style.setProperty(name, value, priority);
      }
    });
  });
  const rootStyle = [doc.documentElement.style.cssText, doc.body.style.cssText]
    .filter(Boolean)
    .join(';');
  if (rootStyle) {
    const section = doc.createElement('section');
    section.setAttribute('style', rootStyle);
    section.innerHTML = doc.body.innerHTML;
    return renderableHtml(section.outerHTML);
  }
  return renderableHtml(doc.body.innerHTML);
}
